export const WAITING_STATUS = 'waiting';
export const FAILED_STATUS = 'failed';
export const SUCCESS_STATUS = 'success';
export const ASNEF_ERROR = 'asnef_error';
